"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openEmailCreationModal = exports.closeModal = exports.ModalActionTypes = void 0;

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-lib/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var ModalActionTypes = (0, _namespacedKeyMirror.default)({
  CLOSE_MODAL: null,
  OPEN_EMAIL_CREATION_MODAL: null
}, 'settings-content-modals');
exports.ModalActionTypes = ModalActionTypes;
var closeModal = (0, _fluxActions.createAction)(ModalActionTypes.CLOSE_MODAL);
exports.closeModal = closeModal;
var openEmailCreationModal = (0, _fluxActions.createAction)(ModalActionTypes.OPEN_EMAIL_CREATION_MODAL, (0, _actions.mapPayloadTo)('modalData'));
exports.openEmailCreationModal = openEmailCreationModal;